export const typePolicies = {
  Query: {
    fields: {
      presentation: {
        read: (_, { args: { id }, toReference }) =>
          toReference({
            __typename: 'Presentation',
            _id: id,
          }),
      },
    },
  },
};
